import { history } from 'instantsearch.js/es/lib/routers'

export function historyRouter() {
  return history({
    windowTitle(routeState) {
      const indexState = routeState.indexName || {}
      const title = document.querySelector('title').text

      if (!indexState.query) {
        return `${title} - Results page`
      }
      return `${title} - Results for: ${indexState.query}`
    },
  })
}
